export function autoOpenIStudioSlide() {
  const iStudioToggle = document.getElementById('expand-toggle')

  if (iStudioToggle) {
    setTimeout(() => {
      if (iStudioToggle.checked === false) {
        iStudioToggle.setAttribute('checked', true)
      }
    }, 3000)
  }
}
